import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../global/GlobalProvider";
import config from "../config";

export default function LiveCasinoInPlay() {
  const initialized = useRef(false);
  const { gameId } = useParams();
  const [liveCasinoApi, setLiveCasino] = useState();
  const token = sessionStorage.getItem("token");
  const [mainHeight, setMainHeight] = useState(0);
  const {openSuccessPopup, openErrorPopup, setAlertMsg } = useContext(GlobalContext);

  const callAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/live_casinoInPlay?gameId=${gameId}`,
      requestOptions
    )
      .then(async (response) => {
        console.log("response code : ",response.status)
        let paresData = await response.json();
        if(response.ok){
          if (!paresData?.urldata?.url && paresData?.urldata?.url == '') {
            openErrorPopup()
            setAlertMsg("No Data Found")
            setTimeout(() => {
                window.location.href = `${config.isWhiteLabel ? '/sport' :'/'}`;
              }, 1000);
          }
          setLiveCasino(paresData);
        }else if(response.status === 401){
            openErrorPopup()
            setAlertMsg(paresData.message)
            setTimeout(() => {
                window.location.href = `${config.isWhiteLabel ? '/sport' :'/'}`;
              }, 1000);
        }else if(response.status === 500){
            openErrorPopup()
            setAlertMsg(paresData.message)
            setTimeout(() => {
                window.location.href = `${config.isWhiteLabel ? '/sport' :'/'}`;
              }, 1000);
      }
    })  
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      callAPI();
    }

    const adjustHeights = () => {
      const header = document.querySelector("header");
      if (!header) return;
      const viewportHeight = window.innerHeight;
      const headerHeight = header.offsetHeight;

      // Calculate remaining height for main content
      setMainHeight(viewportHeight - headerHeight);      
    };

    // Adjust heights on mount and on window resize
    adjustHeights();
    window.addEventListener("resize", adjustHeights);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", adjustHeights);
    };


   
  }, [liveCasinoApi,mainHeight]);

  return (
    <div className="content-box">
      <div className="game-iframe-sec" style={{
          height: `${mainHeight}px`, width:'100%'
        }}>
        {liveCasinoApi?.urldata?.url && liveCasinoApi?.urldata?.url != '' ? <iframe
        style={{ height: `${mainHeight}px`,width:'100%' }}
          src={liveCasinoApi.urldata.url}
          title={gameId}
        />:<p>No Data Found</p>}
      </div>
    </div>
  );
}
